export default __webpack_public_path__ + "static/media/fotoEqualsVenue.1994428c.gif";